import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import "./News.css";

export const NewsCarousel = () => {
  const [carouselNews, setCarouselNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleNewsClick = (newsItem) => {
    const path = newsItem.slug ? `/news/${newsItem.slug}` : `/news/${newsItem.id}`;
    navigate(path);
  };

  const formatRelativeTime = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date)) return "Data inválida";

      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);

      const minutes = Math.floor(diffInSeconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const weeks = Math.floor(days / 7);

      if (weeks > 0) return `há ${weeks} ${weeks === 1 ? "semana" : "semanas"}`;
      if (days > 0) return `há ${days} ${days === 1 ? "dia" : "dias"}`;
      if (hours > 0) return `há ${hours} ${hours === 1 ? "hora" : "horas"}`;
      if (minutes > 0) return `há ${minutes} ${minutes === 1 ? "minuto" : "minutos"}`;

      return "agora mesmo";
    } catch (error) {
      return "Data inválida";
    }
  };

  const ImageRenderer = ({ src, alt }) => {
    if (!src) return null;

    const cleanSrc = src.startsWith("http")
      ? src
      : `https://iscompatible-api.com.br/api/v1/static/${src.replace(/^\/?static\//, "")}`;

    return (
      <img
        src={cleanSrc}
        alt={alt}
        className="modern-carousel-image"
        onError={(e) => {
          e.target.style.display = "none";
        }}
      />
    );
  };

  useEffect(() => {
    const adjustCarouselArrows = () => {
      if (window.innerWidth <= 768) {
        const arrows = document.querySelectorAll('.modern-carousel-container .carousel-control-prev, .modern-carousel-container .carousel-control-next');
        arrows.forEach(arrow => {
          arrow.style.top = '50%';
          arrow.style.transform = 'translateY(-50%)';
          arrow.style.height = '40px';
          arrow.style.width = '40px';
        });
      }
    };

    const fetchCarouselNews = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://iscompatible-api.com.br/api/v1/news/summaries?page=1&limit=5`
        );

        const sortedNews = response.data
          .filter((item) => item.title?.trim())
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setCarouselNews(sortedNews);

        setTimeout(adjustCarouselArrows, 100);
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCarouselNews();

    window.addEventListener('resize', adjustCarouselArrows);

    return () => {
      window.removeEventListener('resize', adjustCarouselArrows);
    };
  }, []);

  return (
    <div className="modern-news-container-carousel">
      <h1 className="modern-news-title">Últimas Notícias</h1>

      {carouselNews.length === 0 && !loading && (
        <div className="no-news-message">
          Nenhuma notícia disponível no momento.
        </div>
      )}

      {carouselNews.length > 0 && (
        <div className="modern-carousel-container">
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            className="modern-carousel"
            interval={5000}
            indicators={false}
            pause={false}
            nextIcon={
              <span
                aria-hidden="true"
                className="carousel-control-next-icon"
                style={{
                  width: '24px',
                  height: '24px',
                  backgroundSize: '100% 100%',
                  filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.5))'
                }}
              />
            }
            prevIcon={
              <span
                aria-hidden="true"
                className="carousel-control-prev-icon"
                style={{
                  width: '24px',
                  height: '24px',
                  backgroundSize: '100% 100%',
                  filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.5))'
                }}
              />
            }
          >
            {carouselNews.map((item) => (
              <Carousel.Item
                key={`${item.slug || item.id}-${item.id}`}
                className="modern-carousel-item"
              >
                <div
                  className="modern-carousel-content"
                  onClick={() => handleNewsClick(item)}
                  style={{ cursor: "pointer" }}
                >
                  {item.thumbnail && (
                    <div className="modern-carousel-image-container">
                      <ImageRenderer
                        src={item.thumbnail}
                        alt={item.title || "Notícia sem título"}
                      />
                    </div>
                  )}

                  <div
                    className="modern-carousel-text"
                    style={{
                      position: "relative",
                      marginTop: "-4px"
                    }}
                  >
                    <h3 className="modern-news-heading">
                      {item.title || "Notícia sem título"}
                    </h3>
                    <div className="modern-excerpt">
                      {item.subtitle || "Nenhum resumo disponível"}
                    </div>
                    <div className="modern-news-meta">
                      <span className="modern-date" title={item.created_at}>
                        {formatRelativeTime(item.created_at)}
                      </span>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
};